import axiosClient from 'utils/axiosClient';
import api from 'api';

const getEffectiveness = async (params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.REPORTS.EFFECTIVENESS, {params});
	return response.data;
};

const getEmployment = async (params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.REPORTS.EMPLOYMENT, {params});
	return response.data;
};

const getEngagement = async (params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.REPORTS.ENGAGEMENT, {params});
	return response.data;
};

const service = {
	getEffectiveness,
	getEmployment,
	getEngagement
};

export default service;
